<template lang="pug">
div
    Button(shape="circle" icon="md-help" size="small"  @click="instance(true)" )
</template>
<script>
export default {
    name: "ExplainURLRewrite",
    props: {},
    data() {
        return {
            "en-US": {
                title: "Scenario",
                content:`<h2>[Basic]: The origin server's API version has been updated, requiring the path to be changed from v1 to <span style="color: green">v2</span>.</h2>
                    <h3>Rule</h3>
                    <ul style="padding-left: 40px;">
                        <li><input type="checkbox" disabled> Iteration:  <span>^\\/api/v1\/</span> -> <span>\/api\/v2</span></li>
                    </ul>

                    <br>
                    <h3>Request Path: /api/v1/domains</h3>
                    <ul style="padding-left: 40px;">
                        <li>Match the rule, and the path is rewritten.</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            Result: <span><strong style="color: green">/api/v2</strong>/domains</span>
                        </span>
                    </p>

                    <br>
                    <br>

                    <h2>[Advanced]: Based on the previous scenario, use multiple configurations to achieve more flexibility.</h2>
                    <h3>Rule</h3>
                    <ul style="padding-left: 40px;">
                        <li><input type="checkbox" disabled checked> Iteration:  <span>^\\/api/v1\/</span> -> <span>\/api\/v2</span></li>
                        <li><input type="checkbox" disabled > Iteration:  <span>/servername</span> -> <span>/domains</span></li>
                        <li><input type="checkbox" disabled > Iteration:  <span>/pems</span> -> <span>/certs</span></li>
                    </ul>

                    <h3>Request Path 1: /api/v1/servername</h3>
                    <ul style="padding-left: 40px;">
                        <li>Match the first rule, and the path is rewritten to <span><strong style="color: green">/api/v2</strong>/servername</span>
                        <br>
                        The first rule's iteration is checked, and it continues to check the second rule after a match.</li>
                        <li>Match the second rule, and the path is rewritten to <span>/api/v2<strong style="color: green">/domains</strong></span>
                        <br>
                        The second rule's iteration is not checked, so it stops checking the third rule.</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            Result: <span><strong style="color: green">/api/v2/domains</strong></span>
                        </span>
                    </p>
                    <br>

                    <h3>Request Path 2: /api/v2/servername</h3>
                    <ul style="padding-left: 40px;">
                        <li>Not matching the first rule.</li>
                        <li>Match the second rule, and the path is rewritten to <span>/api/v2<strong style="color: green">/domains</strong></span>
                        <br>
                        The second rule's iteration is not checked, so it stops checking the third rule.</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            Result: <span>/api/v2<strong style="color: green">/domains</strong></span>
                        </span>
                    </p>
                    <br>

                    <h3>Request Path 3: /api/v2/pems</h3>
                    <ul style="padding-left: 40px;">
                        <li>Not matching the first rule.</li>
                        <li>Not matching the second rule.</li>
                        <li>Match the third rule, and the path is rewritten to <span>/api/v2/<strong style="color: green">certs</strong></span></li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            Result: <span>/api/v2/<strong style="color: green">certs</strong></span>
                        </span>
                    </p>`,
            },
            "zh-CN": {
                title: "应用场景",
                content:`<h2>[基础]: 源站API版本更新，需要将URL路径v1更改为<span style="color: green">v2</span>。</h2>
                    <h3>设置规则</h3>
                    <ul style="padding-left: 40px;">
                        <li><input type="checkbox" disabled>迭代:  <span>^\\/api/v1\/</span> -> <span>\/api\/v2</span></li>
                    </ul>

                    <br>
                    <h3>请求路径(ㄧ): /api/v1/domains</h3>
                    <ul style="padding-left: 40px;">
                        <li>命中第一条规则，进行URL改写。</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最终改写结果: <span><strong style="color: green">/api/v2</strong>/domains</span>
                        </span>
                    </p>

                    <br>
                    <br>

                    <h2>[进阶]: 承上，使用多条配置实现更灵活地改写。</h2>
                    <h3>设置规则</h3>
                    <ul style="padding-left: 40px;">
                        <li><input type="checkbox" disabled checked>迭代:  <span>^\\/api/v1\/</span> -> <span>\/api\/v2</span></li>
                        <li><input type="checkbox" disabled >迭代:  <span>/servername</span> -> <span>/domains</span></li>
                        <li><input type="checkbox" disabled >迭代:  <span>/pems</span> -> <span>/certs</span></li>
                    </ul>

                    <h3>请求路径(ㄧ): /api/v1/servername</h3>
                    <ul style="padding-left: 40px;">
                        <li>命中第一条规则，改写为 <span><strong style="color: green">/api/v2</strong>/servername</span>
                        <br>
                        第一条规则启用迭代，继续检查第二条规则。</li>
                        <li>命中第二条规则，改写为 <span>/api/v2<strong style="color: green">/domains</strong></span>
                        <br>
                        第二条规则未启用迭代，不再检查后续规则。</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最终改写结果: <span><strong style="color: green">/api/v2/domains</strong></span>
                        </span>
                    </p>
                    <br>

                    <h3>请求路径(二): /api/v2/servername</h3>
                    <ul style="padding-left: 40px;">
                        <li>未命中第一条规则。</li>
                        <li>命中第二条规则，改写为 <span>/api/v2<strong style="color: green">/domains</strong></span>
                        <br>
                        未启用迭代，后续规则不再检查。</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最终改写结果: <span>/api/v2<strong style="color: green">/domains</strong></span>
                        </span>
                    </p>
                    <br>

                    <h3>请求路径(三): /api/v2/pems</h3>
                    <ul style="padding-left: 40px;">
                        <li>未命中第一条规则。</li>
                        <li>未命中第二条规则。</li>
                        <li>命中第三条规则，改写为 <span>/api/v2/<strong style="color: green">certs</strong></span></li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最终改写结果: <span>/api/v2/<strong style="color: green">certs</strong></span>
                        </span>
                    </p>`,
            },
            "zh-TW": {
                title: "應用場景",
                content:`<h2>[基礎]: 源站API版本更新，需要將URL路徑v1更改為<span style="color: green">v2</span>。</h2>
                    <h3>設置規則</h3>
                    <ul style="padding-left: 40px;">
                        <li><input type="checkbox" disabled>迭代:  <span>^\\/api/v1\/</span> -> <span>\/api\/v2</span></li>
                    </ul>

                    <br>
                    <h3>請求路徑(ㄧ): /api/v1/domains</h3>
                    <ul style="padding-left: 40px;">
                        <li>命中第一條規則，進行URL改寫。</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最終改寫結果: <span><strong style="color: green">/api/v2</strong>/domains</span>
                        </span>
                    </p>

                    <br>
                    <br>

                    <h2>[進階]: 承上，使用多條配置實現更靈活地改寫。</h2>
                    <h3>設置規則</h3>
                    <ul style="padding-left: 40px;">
                        <li><input type="checkbox" disabled checked>迭代:  <span>^\\/api/v1\/</span> -> <span>\/api\/v2</span></li>
                        <li><input type="checkbox" disabled >迭代:  <span>/servername</span> -> <span>/domains</span></li>
                        <li><input type="checkbox" disabled >迭代:  <span>/pems</span> -> <span>/certs</span></li>
                    </ul>

                    <h3>請求路徑(ㄧ): /api/v1/servername</h3>
                    <ul style="padding-left: 40px;">
                        <li>命中第一條規則，改寫為 <span><strong style="color: green">/api/v2</strong>/servername</span>
                        <br>
                        第一條規則啟用迭代，繼續檢查第二條規則。</li>
                        <li>命中第二條規則，改寫為 <span>/api/v2<strong style="color: green">/domains</strong></span>
                        <br>
                        第二條規則未啟用迭代，不再檢查後續規則。</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最終改寫結果: <span><strong style="color: green">/api/v2/domains</strong></span>
                        </span>
                    </p>
                    <br>

                    <h3>請求路徑(二): /api/v2/servername</h3>
                    <ul style="padding-left: 40px;">
                        <li>未命中第一條規則。</li>
                        <li>命中第二條規則，改寫為 <span>/api/v2<strong style="color: green">/domains</strong></span>
                        <br>
                        未啟用迭代，後續規則不再檢查。</li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最終改寫結果: <span>/api/v2<strong style="color: green">/domains</strong></span>
                        </span>
                    </p>
                    <br>

                    <h3>請求路徑(三): /api/v2/pems</h3>
                    <ul style="padding-left: 40px;">
                        <li>未命中第一條規則。</li>
                        <li>未命中第二條規則。</li>
                        <li>命中第三條規則，改寫為 <span>/api/v2/<strong style="color: green">certs</strong></span></li>
                    </ul>
                    <p>
                        <span style="background-color: #FFFF00">
                            最終改寫結果: <span>/api/v2/<strong style="color: green">certs</strong></span>
                        </span>
                    </p>`
            }
        };
    },
    methods: {
        instance(scrollable) {
            this.$Modal.info({
                width: "800px",
                title: this[this.$i18n.locale].title,
                content: this[this.$i18n.locale].content,
                okText: this.$i18n.t("rcmtable.confirmText"),
                // scrollable: scrollable,
            });
        },
    },
    computed: {},
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainURLRewrite.vue